import React, { useEffect, useState } from 'react';
import { Link, useSearchParams} from 'react-router-dom';
import { ArrowLeft, Dog, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import CareRequestsClient from '@/components/CareRequestsClient';

const ClientRequests = () => {
  const [searchParams] = useSearchParams();
  const isOnboarding = searchParams.get('onboarding') === '1';
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [forceOpenForm, setForceOpenForm] = useState(false);

  useEffect(() => {
    const loadPets = async () => {
      try {
        const res = await api.get('/pets').catch(() => ({ data: [] }));
        setPets(res.data || []);
      } finally {
        setLoading(false);
      }
    };

    loadPets();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-16 h-16 border-4 border-[#E6202E] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" data-testid="client-requests-page">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="mb-6">
          <Link to="/dashboard" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-[#E6202E]">
            <ArrowLeft className="w-4 h-4" />
            Volver al panel
          </Link>
        </div>

        <div className="bg-white rounded-3xl shadow-sm border p-6 md:p-8 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
            <div>
              <p className="text-sm font-semibold text-[#E6202E] mb-2">Centro de solicitudes</p>
              <h1 className="text-3xl md:text-4xl font-black text-gray-900">Mis solicitudes</h1>
              <p className="text-gray-500 mt-2">
                Crea solicitudes, revisa estados y ve las propuestas recibidas.
              </p>
            </div>

            <Button
              onClick={() => setForceOpenForm(prev => !prev)}
              className="bg-[#E6202E] hover:bg-[#D31522] rounded-xl"
            >
              <Plus className="w-4 h-4 mr-2" />
              Nueva solicitud
            </Button>
          </div>
        </div>

        
        {isOnboarding && (
          <div className="mb-6 bg-white rounded-3xl shadow-sm border border-red-100 overflow-hidden">
            <div className="p-6 sm:p-8">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-50 text-[#E6202E] text-sm font-semibold mb-4">
                Primer paso importante
              </div>

              <h2 className="font-montserrat text-3xl font-bold text-gray-900 mb-3">
                ¡Ya casi terminamos!
              </h2>

              <p className="text-gray-600 text-lg mb-5">
                Para que los cuidadores puedan ayudarte, necesitamos que completes tu primera Solicitud de Cuidado.
              </p>

              <div className="grid sm:grid-cols-2 gap-3 mb-6">
                <div className="p-4 rounded-2xl bg-gray-50 border text-gray-700">Cuándo necesitas ayuda</div>
                <div className="p-4 rounded-2xl bg-gray-50 border text-gray-700">Qué mascota cuidarán</div>
                <div className="p-4 rounded-2xl bg-gray-50 border text-gray-700">Dónde será el servicio</div>
                <div className="p-4 rounded-2xl bg-gray-50 border text-gray-700">Detalles importantes del cuidado</div>
              </div>

              <div className="rounded-2xl border border-red-100 bg-red-50 p-5">
                <h3 className="font-bold text-gray-900 mb-2">¿Quieres elegir tú al cuidador?</h3>
                <p className="text-gray-700 mb-3">
                  Con U-CAN Premium además puedes buscar cuidadores directamente, ver más información y contactar sin esperar propuestas.
                </p>
                <p className="text-sm font-semibold text-gray-700 mb-4">
                  No es obligatorio. Puedes hacerlo cuando quieras.
                </p>

                <Link to="/premium">
                  <Button variant="outline" size="sm" className="bg-[#E6202E] hover:bg-[#D31522] text-white shadow-sm font-bold">
                    ⭐ Descubrir U-CAN Premium
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}

        <CareRequestsClient
          pets={pets}
          forceOpenForm={isOnboarding || forceOpenForm}
          hideHeaderButton={true}
          onboardingMode={isOnboarding}
        />
      </div>
    </div>
  );
};

export default ClientRequests;
